import { api } from './configs/axiosConfig';

const endPoint = "/managementfinance";

export const managementFinanceAPI = {
    getRevnueDetails: async function (month, year, pCode) {
        const reponse = await api.request({
            url: endPoint,
            method: 'GET',
            params: { month, year, pCode }
        });

        return reponse.data;
    },

    getTotalCollections: async function (year, pcode) {
        const response = await api.request({
            url: `${endPoint}/total/collection`,
            method: 'GET',
            params: { year, pcode }
        });

        return response.data;
    },

    getTotalSales: async function (year, pcode) {
        const reponse = await api.request({
            url: `${endPoint}/totalsales`,
            method: 'GET',
            params: { year, pcode }
        });

        return reponse.data;
    },

    getCategoryTotalColletion: async function (month, year, pcode) {
        const response = await api.request({
            url: `${endPoint}/category`,
            method: 'GET',
            params: { month, year, pcode }
        });

        return response.data;
    },

    getCustomerOutstanding: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/customeroutstanding`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    },

    getSupplierOutstanding: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/supplierOutstanding`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    },

    getBankBalance: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/bank/balance`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    },

    getFinanceSummary: async function (pcode) {
        const response = await api.request({
            url: `${endPoint}/financesummary`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    },

    getProductivity: async function (month, year, pcode) {
        const response = await api.request({
            url: `${endPoint}/productivity`,
            method: 'GET',
            params: { month, year, pcode }
        });

        return response.data;
    },

}